import { req, post } from '@/plugins/axios'

/**
* 获取市场购类目列表
* @param {Object} data
*/
export function getMarketCateList (data: any) {
  return req('/goods/mall/category/list/frontend', data)
}

/**
* 获取市场购搜索平台
* @param {Object} data
*/
export function getMarketPlatList (data: any) {
  return req('/goods/productMall/frontend', data)
}

/**
* 搜款网营销类目下所有商品
* @param {Object} data
*/
export function marketSearchGoods (data: any) {
  return req('/goods/mall/market/searchGoods', data)
}

/**
 * 搜款网平台类目树结构
 * @param {Object} data
 * @returns
 */

export function marketGroupTreeList (data: any) {
  return req('/goods/mall/market/group/tree/list', data)
}
